import * as gqlr from 'graphql-request'; // GrapgQLClient = module.exports.GrapgQLClient
// Local Deps
import { checkAuth } from './authUtils';
import { apiUrl } from '../config/properties';
// import { cloudFrontCdnUrl } from '../config/properties';
import msgs from '../config/messages';

export async function makeGraphQLRequest({ query, variables = {}, authCheck = true }) {
  let token;

  // Get Token
  const cname = 'idToken';
  const name = `${cname}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      token = c.substring(name.length, c.length);
    }
  }

  // Check Token
  if (authCheck) checkAuth(token);
  // Check for query
  if (!query) throw Error(msgs.Errors.missingQueryArg);
  // Check for token
  if (!token) {
    token = 'VISITOR_AUTH_TOKEN';
  }

  // Send request
  const client = new gqlr.GraphQLClient(`${apiUrl}`, {
    // timeout: 1,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  let results;
  try {
    results = await client.request(query, variables);
  }
  catch (error) {
    console.error('GraphQL request error:', {
      message: error.message,
      query,
      variables: JSON.stringify(variables),
      response: error.response ? error.response : 'No response data',
      status: error.response && error.response.status ? error.response.status : null,
      statusText: error.response && error.response.statusText ? error.response.statusText : null
    });

    // If there's a GraphQL error with response data, log it for debugging
    if (error.response && error.response.errors) {
      console.error('GraphQL detailed errors:', error.response.errors);
    }

    return null;
    /* continue regardless of error */
  }
  return results;
}

export default {
  makeGraphQLRequest,
};



// WEBPACK FOOTER //
// ./src/utils/requestUtils.js